import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import InputGroup from 'react-bootstrap/InputGroup';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';

import settings from '../assets/settings.json';


import {addMenuFunction} from './js/MenuFunction';

import Cookies from 'js-cookie'
import './css/menu.css';


export default class Menu extends Component{
  state={
    download_order_data_url:''
  }
  
  constructor(props) {
    super(props);
  }
  
  componentDidMount () {
    console.dir(this.props.data);
    let download_order_data_url = settings.API_BASE_URL + 'download_csv_create/' + '?what_type=order_data&token='+this.props.data.auth_obj.token+'&name='+ this.props.data.auth_obj.name;
    this.setState({download_order_data_url:download_order_data_url});
  }

  clickOpenMenu = async (e) => {
		this.props.clickMenu(false);
	}
  
  
  render(){
    var ckickDownloadFileButton = async (e) => {
      console.log(e.target.id);

      //let what_type = e.target.id.replace('download__', '');
      //let res = addMenuFunction.downloadFile(what_type, staff_token, staff_name);

    }


    return (
      <div className="menu">
        <ul>
          <li>ダウンロード：<a href="/cm-everyone" target="_blank" className="text-decoration-none">Order_data.xlsx</a></li>
        </ul>

        <div className="jan-info-close-button click-pointer-elem" onClick={this.clickOpenMenu}><i className="bi bi-x-circle"></i></div>

      </div>
    );
  }
}